import axios from 'axios';

/**
 * Liste des actions
 */
export const Actions = {
    FETCH_PIECES_GESTION_REQUEST: 'FETCH_PIECES_GESTION_REQUEST',
    FETCH_PIECES_GESTION_SUCCESS: 'FETCH_PIECES_GESTION_SUCCESS',
    FETCH_PIECES_GESTION_FAILURE: 'FETCH_PIECES_GESTION_FAILURE',

    UPDATE_SEARCH_PIECE_FILTERS: 'UPDATE_SEARCH_PIECE_FILTERS',
    CLEAR_SEARCH_PIECE_FILTERS: 'CLEAR_SEARCH_PIECE_FILTERS',

    CLEAR_PIECES_GESTION: 'CLEAR_PIECES_GESTION'
};

/**
 * ActionCreator pour FETCH_PIECES_GESTION...
 */
const fetchPiecesGestionRequest = (namespace) => ({
    type: `${namespace}/${Actions.FETCH_PIECES_GESTION_REQUEST}`
});
const fetchPiecesGestionSuccess = (namespace, piecesGestion) => ({
    type: `${namespace}/${Actions.FETCH_PIECES_GESTION_SUCCESS}`, piecesGestion
});
const fetchPiecesGestionFailure = (namespace, error) => ({
    type: `${namespace}/${Actions.FETCH_PIECES_GESTION_FAILURE}`, error
});

/**
 * ActionCreator pour la récupération des pièces gestion
 */
export const fetchPiecesGestion = (namespace, client) => async (dispatch, getState) => {
    dispatch(fetchPiecesGestionRequest(namespace));

    try {
        let criteres = getState().pieceGestion[namespace].piecesGestion.criteres;

        let response = await axios.get('api/pieces-gestion', {
            params: {
                mode: namespace,
                type: criteres.typeRecherche,
                numeroPiece: criteres.numeroPiece,
                referenceCommande: criteres.referenceCommande,
                dateDebut: criteres.dateDebut,
                dateFin: criteres.dateFin,
                article: criteres.article,
                codeClient: client !== null ? client.code : null,
                codeFournisseur: criteres.codeFournisseur
            }
        });

        dispatch(fetchPiecesGestionSuccess(namespace, response.data));

    } catch (error) {
        dispatch(fetchPiecesGestionFailure(namespace, error));
    }
};

/**
 * ..._RECHERCHE
 * ActionCreator pour la récupération des critères de recherche de pièce
 */
export const updateSearchPieceFilters = (namespace, criteres) => ({
    type: `${namespace}/${Actions.UPDATE_SEARCH_PIECE_FILTERS}`, criteres
});
export const clearSearchPieceFilters = (namespace) => ({
    type: `${namespace}/${Actions.CLEAR_SEARCH_PIECE_FILTERS}`
});

/**
 * ActionCreator pour CLEAR_PIECES_GESTION
 */
export const clearPiecesGestion = (namespace) => ({
    type: `${namespace}/${Actions.CLEAR_PIECES_GESTION}`
});


// Appel le WiService de génération du pdf de la pièce
export const genererPDF = (cle) => (dispatch, getState) => {
    try {
        let response = axios.post(`api/pieces-gestion/${cle}/generer-pdf`);

        return response;
    } catch (error) {
        console.error('genererPDF : ', error);
    }
};
